import { Component, EventEmitter, Input, OnInit, Output, TemplateRef, ViewChild } from '@angular/core';
import { debounceTime, distinctUntilChanged, startWith, takeLast } from 'rxjs/operators';
import { FormControl } from '@angular/forms';
import { UpdateAddressService } from './update-address.service';
import { Addresses } from '../../entity/address';

@Component({
    selector: 'app-update-address',
    templateUrl: './update-address.component.html',
    styleUrls: ['./update-address.component.scss'],
    standalone: false
})
export class UpdateAddressComponent implements OnInit {

  @Input() taskId: string;
  @Output() closeDialog = new EventEmitter<boolean>();
  @Output() onCancel = new EventEmitter<boolean>()

  isUpdateBtnDisabled: boolean = true;
  errorMessage:string | undefined;

  @ViewChild('updateAddressFooter', {static:true})  updateAddressFooter!: TemplateRef<any>

  constructor(
    private readonly updateAddressService: UpdateAddressService
  ) {
    this.updateAddressService.notifyError$.subscribe((res:string) => {
      if(res) {
        this.errorMessage = res;
      } else {
        this.errorMessage = undefined
      }
    })
  }


  ngOnInit(): void {
    this.onClearSelection();
  }

  searchAddress(searchText:string) {
    this.updateAddressService.searchAddress(searchText??'').pipe(takeLast(1)).subscribe((addressRes => {
      this.updateAddressService.formUpdateAddressObject(addressRes, this.taskId);
      this.updateAddressService.addressData = addressRes;
      this.isUpdateBtnDisabled = false;
    }));
  }

  /**
   * Method updates the address object with address result and also sets the class variables
   * @param searchText searched address text
   */
  updateAddressData(searchText: string) {
    this.updateAddressService.searchAddress(searchText??'').pipe(takeLast(1)).subscribe((addressRes => {
      this.updateAddressService.formUpdateAddressObject(addressRes, this.taskId);
      this.updateAddressService.addressData = addressRes;
      this.isUpdateBtnDisabled = false;
    }));
  }

  /**
   * Method clears the controls and resets update address activity
   */
  onClearSelection() {
    this.updateAddressService.addressData = {} as Addresses;
  }

  /**
   * Method called when clear icon is clicked on p-autocomplete control, it disbales the submit button
   * and removed the error banner if any
   * @param event event object
   */
  clearValue(event:any){
    this.isUpdateBtnDisabled = true;
    this.onClearSelection();
    this.updateAddressService.showError('');
  }

  /**
   * Method closes the popup and flags FALSE for display property
   */
  closePopup(refreshData = false) {
    this.onClearSelection();
    if(refreshData) {
      this.closeDialog.emit(true);
    } else {
      this.onCancel.emit(true);
    }
  }

  /**
   * Method submits the searched address against the selected task ID to backend 
   * and closes the popup
   */
  submitAddress() {
    this.updateAddressService.submitAddress().pipe(takeLast(1)).subscribe((updateAddressRes => {
      if (updateAddressRes) {
        this.closePopup(true);
      }
    }));
  }

  get addressData() {
    return this.updateAddressService.addressData;
  }

  set addressData(value: Addresses) {
    this.updateAddressService.addressData = value;
  }
}
